// extracted by mini-css-extract-plugin
export var avatar = "_ov-3";
export var avatarContainer = "_ov-2";
export var avatarSpacer = "_ov-5";
export var avatarSpacerContainer = "_ov-4";
export var avatarStackContainer = "_ov-1";
export var bubble = "_ov-0";
export var remainderBubble = "_ov-6";